<template>
  <div class="gs_container">
    <div class="gs_crumb">
      <el-breadcrumb separator-class="el-icon-arrow-right">
        <el-breadcrumb-item
          ><span class="local">你的位置</span></el-breadcrumb-item
        >
        <el-breadcrumb-item>代付模块</el-breadcrumb-item>
        <el-breadcrumb-item>版本管理</el-breadcrumb-item>
      </el-breadcrumb>
    </div>

    <div class="search-box">
      <div class="item">
        商户ID：
      </div>
      <div class="item w1">
        <el-select v-model="form.MerchantId" filterable size="small">
          <el-option
            v-for="item in view.merchantIdList"
            :key="item"
            :label="item"
            :value="item"
          >
          </el-option>
        </el-select>
      </div>
      <div class="item">
        模式：
      </div>
      <div class="item">
        <el-select placeholder="请选择" size="small" v-model="form.IsAutoPay">
          <el-option label="手动转出" :value="false"> </el-option>
          <el-option label="自动转出" :value="true"> </el-option>
        </el-select>
      </div>
      <div class="item">
        <el-button type="danger" size="small" @click="search">查询</el-button>
        <el-button size="small" @click="reset">重置</el-button>
      </div>
    </div>
    <div class="tips">
      商户总数：<font color="#ff0000">{{ view.totalMerchant }}</font
      >人，已开通代付功能：<font color="#ff0000">{{ view.paidMerchant }}</font
      >人
    </div>
    <el-table
      ref="singleTable"
      :data="tableData"
      highlight-current-row
      border
      style="width: 100%"
    >
      <el-table-column type="index" width="50" align="center">
      </el-table-column>
      <el-table-column
        property="applicationUserId"
        label="商户ID"
        align="center"
      >
      </el-table-column>
      <el-table-column property="versionName" label="版本名称" align="center">
      </el-table-column>
      <el-table-column
        property="transferRecordUrl"
        label="查看转出记录地址(游戏中使用)"
        align="center"
      >
      </el-table-column>
      <el-table-column property="isAutoPay" label="当前模式" align="center">
        <template slot-scope="scope">
          <font v-if="scope.row.isAutoPay">自动转出</font>
          <font color="#FF0000" v-else>手动转出</font>
        </template>
      </el-table-column>
      <el-table-column label="秒到帐失效时间段" align="center">
        <template slot-scope="scope">
          {{ scope.row.startTime }} - {{ scope.row.endTime }}
        </template>
      </el-table-column>
    </el-table>
    <div class="mgt15 mgb15 mgl15 mgr15" style="text-align: center;">
      <el-pagination
        background
        layout="prev, pager, next"
        :total="form.total"
        :current-page="form.PageNumber"
        :page-size="form.PageSize"
        @current-change="changePage"
      >
      </el-pagination>
    </div>
  </div>
</template>

<script>
import mgr from '../../assets/js/securityapi';
import api from '../../assets/js/apiRequestHandler';
export default {
  data() {
    return {
      form: {
        MerchantId: '',
        IsAutoPay: '',
        Id: '',
        PageNumber: 1,
        PageSize: 10,
        total: 0
      },
      tableData: [],
      view: {}
    };
  },
  created() {
    this.getLists();
    this.getView();
  },
  methods: {
    async getLists() {
      let header = await mgr();
      for (let i in this.form) {
        if (this.form[i] === '') {
          delete this.form[i];
        }
      }
      api
        .get('/api/Paid/GetPaidVersionList', {
          headers: {
            Authorization: 'Bearer ' + header
          },
          params: this.form
        })
        .then(res => {
          if (res.status === 200) {
            this.form.total = JSON.parse(
              res.headers['x-pagination']
            ).TotalCount;
            this.tableData = res.data;
          }
        })
        .catch(err => {
          this.$messageError(err.message);
        });
    },
    async getView() {
      let header = await mgr();
      api
        .get('/api/Paid/GetPaidVersionInfo', {
          headers: {
            Authorization: 'Bearer ' + header
          },
          params: {}
        })
        .then(res => {
          if (res.status === 200) {
            this.view = res.data;
          }
        })
        .catch(err => {
          this.$messageError(err);
        });
    },
    search() {
      this.tableData = [];
      this.form.PageNumber = 1;
      this.getLists();
    },
    changePage(page) {
      console.log(page);
      this.form.PageNumber = page;
      this.getLists();
    },
    reset() {
      this.form = {
        MerchantId: '',
        IsAutoPay: '',
        Id: '',
        PageNumber: 1,
        PageSize: 12
      };
      this.tableData = [];
      this.getLists();
    }
  }
};
</script>

<style scoped>
.gs_container {
  background-color: #fff;
}

.search-box {
  display: flex;
  align-items: center;
  font-size: 14px;
  margin-top: 20px;
}

.search-box .item {
  margin-right: 10px;
}

.tips {
  font-size: 14px;
  margin-top: 15px;
  margin-bottom: 15px;
}

.pagination {
  text-align: center;
  margin: 20px 0;
}
</style>
